module.exports = __webpack_public_path__ + "static/media/gvt.1bdab0fe.svg";